import { IFieldSubmissionMap, IFormFieldSubmission } from "@common/redux/formSubmission/interface";
import { FieldRulesDetails, IFieldRuleConfig, MAX_DATE_TIME, MIN_DATE_TIME, DATE_TIME_ALLOWED, DATE_TIME_NOT_ALLOWED} from "@presentation/FormBuilder/Rules/config";
import { validateSubRule } from "@presentation/FormBuilder/utils";
import { FieldProps } from "../../FormFieldSelector/interfaces";

export const validateDateTimePickerFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const { isRequired, rules: fieldRules, isVisible } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;


  const submissionValue = (fieldSubmissionValue && fieldSubmissionValue?.value) || "";
  if (isRequired && !!isVisible) {
    if (!submissionValue) {
      return [false, "This is a Required Field"];
    }
  }
  if (fieldRules) {
    for (let i = 0; i < fieldRules?.length; i++) {
      const [isValidated, validatationErrorMessage] = validationRule(
        fieldRules[i],
        submissionValue,
        fieldSubmissionMap
      );

      if (!isValidated && validatationErrorMessage != "") {
        return [isValidated, validatationErrorMessage];
      }
    }
  }

  return [true, ""];
};

export const validationRule = (fieldRule: IFieldRuleConfig, submissionValue: any,fieldSubmissionMap: IFieldSubmissionMap): [boolean, string] => {
  const {rule, value, errorMessage, subRules} = fieldRule;
  const ruleType: string = rule;
  const ruleValue: any = value;
  const ruleErrorValue: string = errorMessage;
  const submissionDateTimeValue = String(submissionValue);
  switch (ruleType) {
    case "MAX_DATE_TIME":
      if (ruleValue < submissionDateTimeValue)
        return [false, ruleErrorValue];

      break;

    case "MIN_DATE_TIME":
      if (ruleValue > submissionDateTimeValue)
        return [false, ruleErrorValue];
      break;

    case "DATE_TIME_ALLOWED":
      if (ruleValue != submissionDateTimeValue)
        return [false, ruleErrorValue];
      break;
  
    case "DATE_TIME_NOT_ALLOWED":
      if (ruleValue == submissionDateTimeValue)
        return [false, ruleErrorValue];
      break;
    default:
      break;
  }

  if(fieldRule?.subRules?.length > 0 ){
    const [isValidated, validatationErrorMessage] = validateSubRule(fieldRule, submissionValue, fieldSubmissionMap, validationRule);
    return [isValidated, validatationErrorMessage];
  }
  
  return [true, ""];
};


export const getInitialRuleConfigDateTimePicker = (
  rule: string
): IFieldRuleConfig => {
  const ruleDetails = FieldRulesDetails[rule];

  switch (rule) {
    case MAX_DATE_TIME:
    case MIN_DATE_TIME:
    case DATE_TIME_ALLOWED:
    case DATE_TIME_NOT_ALLOWED:

      return {
        rule,
        value: "",
        errorMessage: ruleDetails?.defaultErrorMessage || "",
      };
    default:
      return {
        rule,
        value: "",
        errorMessage: "",
      } as IFieldRuleConfig;
  }
};
